// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--jsm-phantom/jira-issue-view-playbooks-panel';

import { MessageFrontend as createMessageFrontendJiraPlaybookPanelOnboardingMessage } from '@post-office/browser--jsm-phantom/jira-playbook-panel-onboarding-message/placements/in-app-v2/jira-issue-view-playbooks-panel';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type PlacementFrontendProps } from '@post-office/browser--jsm-phantom/jira-issue-view-playbooks-panel';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendJiraPlaybookPanelOnboardingMessage({
		messageTemplateId: 'jira-playbook-panel-onboarding-message',
	}),
];

export const RawPlacement: PlacementRendererStage<PlacementFrontendProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<PlacementFrontendProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<PlacementFrontendProps> = RawPlacement;
